import { useActionSignatureContext } from "app/features/actionSignature/providers/ActionSignatureProvider";
import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { useSignOffMedicationMutation } from "app/services/api/medicationsApi";
import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";
import { useDisplayToast } from "ui/hooks/useDisplayToast";

export function useHandleSignOffMedication() {
  const { residentId } = useResidentContext();
  const { showActionSignatureModal } = useActionSignatureContext();
  const { showNewToast, showErrorToast } = useDisplayToast();
  const [triggerSignOff] = useSignOffMedicationMutation();

  const handleSignOffMedication = async ({
    id,
  }: Pick<MedicationModel, "id">) => {
    try {
      if (!residentId) return;

      const password = await showActionSignatureModal({
        title: "Sign Off Medication",
        description:
          "Please enter your password to sign off on this medication",
      });
      await triggerSignOff({
        medication: id,
        residentId,
        body: password,
      });
      showNewToast({
        title: "Medication signed successfully",
        message: "The medication has been signed off successfully",
        type: "success",
      });
    } catch (e) {
      showErrorToast(e);
    }
  };
  return {
    handleSignOffMedication,
  };
}
